// KL - personal trainer for elderly (warga emas).
const content = {
    slug: 'personal-trainer-for-elderly',
    title: 'Personal Trainer for Elderly in KL | Home Sessions for Warga Emas',
    description: (c) =>
        `Personal training for elderly parents in Kuala Lumpur: gentle strength, balance and mobility at home. Packages from ${c.money(c.lowest, 0)} a session.`,
    eyebrow: 'KL · Elderly',
    h1: 'Personal Trainer for Elderly in Kuala Lumpur',
    lead: 'Many KL families book a trainer for their parents - to keep them walking confidently, getting up from chairs easily, and active enough to enjoy the grandchildren. Sessions happen at home, at a gentle pace.',
    image: 'blog/health+and+fitness/elderly-fitness.webp',
    imageAlt: 'Elderly woman doing a gentle strength exercise',
    facts: ['At home', 'Fall prevention', 'Booked by family'],
    ctaLabel: 'Book for a parent',
    matchSummary: 'a personal trainer for an elderly parent in KL',
    packagesTitle: 'Packages for warga emas',
    packagesIntro: 'Two sessions a week is plenty to start. Weekday daytime slots are the lowest price - convenient for retirees.',
    sections: [
        {
            title: 'What we work on',
            cards: [
                { title: 'Getting up and sitting down', body: 'Chair stands and supported squats - the movement that keeps people independent.' },
                { title: 'Walking and balance', body: 'Steadier steps and fewer falls, inside the house and on uneven pavements.' },
                { title: 'Grip and arms', body: 'Carrying groceries, lifting a grandchild, opening jars.' },
                { title: 'Joints', body: 'Gentle mobility for knees, hips and shoulders, especially with arthritis.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'For families booking on behalf of parents',
            tone: 'muted',
            paragraphs: [
                'You can book and pay for the sessions while your parent trains at their own home - even in a different part of the Klang Valley. Share health conditions such as diabetes, high blood pressure, a past stroke or joint replacement; the trainer asks for the doctor\'s advice where needed and keeps you updated on progress.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Is personal training safe for elderly people?',
            answer: 'Yes, when it is adapted to them. Trainers start slowly, watch every movement and work within any limits set by the doctor.',
        },
        {
            question: 'Can the trainer speak Malay, Mandarin or Tamil?',
            answer: 'Tell us your parent\'s preferred language when you book and we will try to match it.',
        },
        {
            question: 'What equipment is needed at home?',
            answer: 'A sturdy chair and a little space. The trainer brings light weights and bands.',
        },
    ],
    schema: { name: 'Personal Training for Elderly in Kuala Lumpur' },
}

export default content
